<template>
  <v-container>
    <v-card>
      <v-toolbar card color="blue darken-3" dark>
        <v-toolbar-title>Background</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>

      <p class="pa-5">
        The North Queensland Strata Title Inspection Program is a three-year
        project that is the development and carrying out of an inspection and
        assessment program for Body Corporate properties in North Queensland.
        The $12.5 million, three-year program is funded by the Federal
        Government, administered by the Queensland Government, and independently
        developed and deployed by James Cook University. It will improve the
        information available to those Body Corporates about a properties
        susceptibility to weather damage and ways to make properties more
        resilient. The Program is a long-term project that is to deliver an
        ongoing legacy of more resilient Strata Title properties, which will
        reduce cyclone impacts, and recovery time of communities. The location
        of the program includes those coastal areas within the combined regions
        B & C as indicated on the Australian Wind loading Map. It also
        incorporates areas north of the southernmost boundary of the Rockhampton
        Regional council area extending to the Qld/NT border and extending
        100kms in from the coast incorporating islands of the coast.
      </p>
    </v-card>
  </v-container>
</template>

<script>
import { router } from "../router";
import jwt_decode from "jwt-decode";
import { Email } from "../smtp/smtp";
import { checkLogin } from '../helpers/check'

export default {
  data() {
    return {
      selected: ["John Doe"],
      items: ["John Doe", "Jane Doe"],
      title: "Enter your feedback.",
      subject: "",
      submitDialog: false
    };
  },
  mounted: function() {
    this.checkLoggedIn();
  },
  methods: {
    checkLoggedIn() {
      if (checkLogin()) {
        router.push("/login");
      }

    },
    inspectToken() {
      const token = this.$session.has("token");
      if (token) {
        const decoded = jwt_decode(sessionStorage.getItem("token"));
        const exp = decoded.exp;
        const orig_iat = decoded.orig_iat;

        if (exp - Date.now() / 1000 < 1800) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    feedback() {}
  }
};
</script>
